<script setup lang="ts">
import GbButton from '@/components/GbButton.vue'
import { goalbookUrls } from '@/util/links'

const goHome = () => (window.location.href = goalbookUrls.toolkitHome)
</script>

<template>
  <div class="container flex min-h-[50vh] w-full flex-col items-center justify-center">
    <h1 class="text-display-lg font-medium">There was an error loading the goal. Please refresh and try again.</h1>
    <GbButton gbTheme="bluePrimary" class="m-8" @click="goHome">Back to Toolkit Home</GbButton>
  </div>
</template>
